import { useState, useEffect } from 'react';
import { InputDinamycPlaceholder } from '@lk-gtcom/ecomlab-components';
import { KonstantionAuthHttps } from '../../fetchUrls';
import Cookies from 'universal-cookie';
import './PasswordRecoveryPage.scss';
import { validationEmail } from '../../common/validationFunc';
import done from './img/done-green.svg'
import err_icon from './img/image.png'
import { ButtonBasic } from '@lk-gtcom/ecomlab-components';
import { ModalComponent } from '../../components/Modal/ModalComponent/ModalComponent';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { TextPage } from '../../components/TextPage/TextPage';

const PasswordRecoveryPage = ({ setIsModal }) => {

  const [email, setEmail] = useState('');
  const [errEmail, setErrEmail] = useState(false);

  const [incorrectEmail, setIncorrectEmail] = useState(false);
  const [activeContent, setActiveContent] = useState(true);
  const [isModalErr, setIsModalErr] = useState(false);
  const [isModalMail, setIsModalMail] = useState(true);
  const auth = new Cookies().get('auth');

  const handlerSetEmail = (e) => {
    setIncorrectEmail(false);
    setErrEmail(false);
    setEmail(e);
  };

  const checkInputField = () => {
    if (!validationEmail(email)) {
      setErrEmail(true);
    }

    if (validationEmail(email)) {
      handlerSubmit();
    }
  };

  const handlerSubmit = (e) => {
    let url = `${KonstantionAuthHttps}/web/forgot-password`;

    const headers = {
      'Content-type': 'application/json',
      Authorization: `Bearer ${auth}`,
      'portal-id': '4',
    };

    const body = JSON.stringify({
      email,
    });

    fetch(url, { body, method: 'POST', headers })
      .then((res) => res.json())
      .then(async (json) => {
        setIsModalMail(true);
        setActiveContent(false);
      })
      .catch((err) => {
        setIsModalErr(true);
        console.error(err);
      });
  };

  return (
    <>
      <ModalComponent
        title="Восстановление пароля"
        onClose={e => setIsModal(false)}
        style={{
          maxWidth: '500px',
          height: 'auto'
        }}
        child={
          <div className="password-recovery">
            {activeContent
              ?
              <>
                <InputDinamycPlaceholder
                  onChange={(e) => handlerSetEmail(e)}
                  type="e-mail"
                  placeholder="E-mail"
                  err={errEmail}
                  textErr="Неверный e-mail формат"
                />

                <ButtonBasic
                  blue
                  text="Восстановить пароль"
                  onClick={checkInputField}
                />
              </>
              :
              <>
                {isModalErr
                  ?
                  <>
                    <img src={err_icon} />
                    <TitlePage
                      medium
                      title='Что-то пошло не так'
                    />
                    <TextPage
                      text='Попробуйте перезагрузить страницу'
                    />
                  </>
                  :
                  <>
                    <img className='modal-mail__img' src={done} />
                    <TitlePage
                      title='Проверьте электронную почту'
                      medium />
                    <TextPage
                      text={`Мы отправили инструкцию для восстановления пароля на ${email || 'ваш email'}`}
                    />
                  </>
                }
                <ButtonBasic
                      blue
                      text='Ok'
                      width='auto'
                      onClick={(e) => setIsModal(false)}
                    />
              </>
            }
          </div>
        }
      />
    </>
  );
};

export { PasswordRecoveryPage };
